import useCustomMemo from "../../Hooks/useCustomMemo";
import withRole from "../../Hooks/withRole";
import genericStyles from "../../Styles/genericStyles.module.css";
import Config from "../../Utils/Config";
import { EComponentTypes, ETableEditAction } from "../../Utils/Enums";
import { WorkPointModel } from "../../Utils/Models";
import { endpoints } from "../../Utils/UrlEnum";
import { formatDate } from "../../Utils/Utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import Filters from "../Widgets/Filters";
import { ExpirationStatusBadge } from "../ExpirationStatusBadge";

interface CarDocumentsExpirationProps {
  name?: string;
  restrictByWorkPoint?: boolean;
}

function CarDocumentsExpiration(props: CarDocumentsExpirationProps) {
  const memo = useCustomMemo();
  const workPoints: WorkPointModel[] = memo?.storage?.workPoints || [];
  const userWorkPointId = localStorage.getItem("userWorkPointId");

  // Get default workPoint for functionar users
  const defaultWorkPoint = props.restrictByWorkPoint && userWorkPointId
    ? workPoints.find((wp: WorkPointModel) => wp._id === userWorkPointId) || null
    : null;
  const columns = [
    {
      name: "isExpired",
      label: Vocabulary.isExpired,
      options: {
        display: false,
      },
    },
    {
      name: "workPointId",
      label: Vocabulary.workPoint,
      options: {
        customBodyRender: (workPoint: WorkPointModel) => {
          return workPoint?.name;
        },
        exportValue: (workPoint: WorkPointModel) => {
          return workPoint?.name || "";
        }
      },
    },
    {
      name: "brand",
      label: Vocabulary.brand,
    },
    {
      name: "model",
      label: Vocabulary.model,
    },
    {
      name: "vehicleNumber",
      label: Vocabulary.vehicleNumber,
    },
    {
      name: "document",
      label: Vocabulary.expirationDocumentDate,
      options: {
        customBodyRender: (document: any) => {
          return formatDate(document?.expirationDate);
        },
        exportValue: (document: any) => {
          return formatDate(document?.expirationDate) || "";
        },
      },
    },
    {
      name: "document",
      label: Vocabulary.documentName,
      options: {
        customBodyRender: (document: any) => {
          return document?.name || document?.document;
        },
        exportValue: (document: any) => {
          return document?.name || document?.document || "";
        },
      },
    },
    {
      name: "monthsTillExpiration",
      label: Vocabulary.nrOfRemainingMonths,
      options: {
        customBodyRender: (value: number, tableMeta: any) => {
          const isExpired = tableMeta?.rowData?.[0];
          return <ExpirationStatusBadge value={value} isExpired={isExpired} />;
        },
      },
    },
  ];

  const filters = [
    {
      property: "workPointId",
      autocompleteFilterProperty: "_id",
      label: Vocabulary.workPoint,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: null,
      defaultValue: defaultWorkPoint,
      options: workPoints,
      disableFlag: props.restrictByWorkPoint,
    },
    {
      property: "documentName",
      autocompleteFilterProperty: "name",
      label: Vocabulary.documentType,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: null,
      defaultValue: null,
      options: Config.vehicleDocuments.map((doc: string) => ({
        name: doc,
      })),
    },
  ];
  return (
    <div className={genericStyles.mainContainer}>
      <Filters filters={filters} defaultOpen />
      <MUIDataTableCustomStyle
        buttons={[]}
        onEditAction={ETableEditAction.NONE}
        title={""}
        hideAddButton={true}
        columns={columns}
        CRUDEndPoint={endpoints.vehicle.expiredDocuments}
        hideEditButton={true}
        hideDeleteButton={true}
        showDownloadButton
        showPrintButton
        exportWithTimestamp
      />
    </div>
  );
}

export default withRole(CarDocumentsExpiration);
